var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zhenhe"},[_c('lff',{ref:"lff",on:{"spon":_vm.transfer}}),_c('lzg',{ref:"lzg",on:{"spon":_vm.transfer}}),_c('myFooter',{attrs:{"theme":"dark"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }